import React from "react";
import "./head-block.m.css";

export const HeadBlock = ({ group = {}, subscriptionConfig = {}, mode }) => {
  const { image_url: imageUrl = "", name } = group;
  const { pageTitle = "", pageDescription = "" } = subscriptionConfig;
  const emptyString = "<p><br></p>";
  const updatedPageTitle = pageTitle === emptyString ? "" : pageTitle;
  const updatedPageDescription = pageDescription === emptyString ? "" : pageDescription;
  const displayPageDetails = updatedPageTitle || updatedPageDescription;
  const style = imageUrl && displayPageDetails ? "space" : "align-center";
  if (displayPageDetails || imageUrl) {
    return (
      <div styleName={`wrapper ${style} ${mode}`}>
        {displayPageDetails && (
          <div>
            {updatedPageTitle && <h1 styleName="page-title" data-test-id="page-title" dangerouslySetInnerHTML={{ __html: pageTitle }} />}
            {updatedPageDescription && (
              <div styleName="page-description" data-test-id="page-description" dangerouslySetInnerHTML={{ __html: pageDescription }} />
            )}
          </div>
        )}
        {imageUrl && (
          <div styleName="group-image" data-test-id="group-image">
            <img src={imageUrl} alt={name} />
          </div>
        )}
      </div>
    );
  }
  return null;
};
